import { useMutation, useQueryClient } from '@tanstack/react-query';
import bankAccountsApi from '@/features/dashboard/paymentConfig/api/bankAccountsApi.ts';
import { bankAccountsApiQueryKeys } from '@/features/dashboard/paymentConfig/api/bankAccountsApi.queryKeys.ts';
import { toast } from 'sonner';

export default function useSetDefaultBankAccount() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => bankAccountsApi.setDefault(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bankAccountsApiQueryKeys.all(),
      });
      toast.success('Konto bankowe zostało ustawione jako domyślne');
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message ||
          'Wystąpił błąd podczas ustawiania domyślnego konta bankowego.',
      });
    },
  });
}
